<template>
    <div>
        <ModalCommon :id="`configModalCommonPreview-${config?.id ?? ''}`" :config="config" @save="setConditionRule()" @close="handleClose()">
            <form class="needs-validation" autocomplete="off">
                <div :style="`height: ${loading ? '78vh' : '100%'}`">
                    <div v-if="!loading">
                        <div class="form-group row">
                            <label class="col-sm-1" style="min-width: 180px">エンドクライアント <span class="text-danger">*</span></label>
                            <div class="col-sm-10 pl-0">
                                <Multiselect
                                    :id="`select-campaign`"
                                    :value.sync="dataForm.client"
                                    :options="masterClients"
                                    :config.sync="configFieldSelectClient"
                                />
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-sm-1" style="min-width: 180px">応募種別 </label>
                            <div class="col-sm-10">
                                <div class="d-flex flex-wrap">
                                    <div v-for="item in listCategoriesMaster" :key="item.id + 'sss'">
                                        <InputCheckBox
                                            class="mr-4"
                                            :model.sync="dataForm.platforms"
                                            :id="`checka${item.id}`"
                                            :value="item.id"
                                            :label="item.value"
                                            @change="handleChangeCategory(item.value)"
                                            :disabled="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mb-2">
                            <button type="button" @click="getDetailRule" class="btn btn-primary mr-3">条文・細則を表示する</button>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr v-if="ruleType1 && ruleType1.length > 0">
                                            <td :rowspan="ruleType1 && ruleType1.length" class="font-weight-bold">共通</td>
                                            <td style="width: 70px; text-align: center">
                                                <div>
                                                    <InputCheckBox
                                                        :model.sync="dataForm.rules"
                                                        :id="`checkard${ruleType1[0].id}`"
                                                        :value="ruleType1[0].id"
                                                        :label="``"
                                                    />
                                                </div>
                                            </td>
                                            <td :class="`${isActiveNotAutoCheck(ruleType1[0].id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                {{ ruleType1[0].rule }}
                                            </td>
                                        </tr>
                                        <template v-for="(item, k) in ruleType1">
                                            <tr v-if="k > 0" :key="item.id">
                                                <td style="width: 70px; text-align: center">
                                                    <div>
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkard${item.id}`"
                                                            :value="item.id"
                                                            :label="``"
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div :class="`${isActiveNotAutoCheck(item.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ item.rule }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="campaignType === 'クローズ'">
                                            <tr v-if="ruleType2 && ruleType2.length > 0">
                                                <td :rowspan="ruleType2.length" class="font-weight-bold">クローズ</td>
                                                <td style="width: 70px; text-align: center">
                                                    <div>
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${ruleType2[0].id}`"
                                                            :value="ruleType2[0].id"
                                                            :label="``"
                                                        />
                                                    </div>
                                                </td>
                                                <td :class="`${isActiveNotAutoCheck(ruleType2[0].id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                    {{ ruleType2[0].rule }}
                                                </td>
                                            </tr>
                                            <template v-for="(item, k) in ruleType2">
                                                <tr v-if="k > 0" :key="item.id">
                                                    <td style="width: 70px; text-align: center">
                                                        <div>
                                                            <InputCheckBox
                                                                :model.sync="dataForm.rules"
                                                                :id="`checkar${item.id}`"
                                                                :value="item.id"
                                                                :label="``"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div
                                                            v-html="item.rule"
                                                            :class="`${isActiveNotAutoCheck(item.id) ? 'rule__condition_checked_not_auto' : ''}`"
                                                        ></div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>

                                        <!-- type3 -->
                                        <template v-for="(rules, platform) in groupedRules3">
                                            <!-- Show mục LINE -->
                                            <template v-if="platform === 'LINE' && platformsChecked.some((item) => item.value == 'LINE')">
                                                <tr v-for="(rule, index) in rules" :key="rule.id">
                                                    <!-- Chỉ hiển thị platform ở dòng đầu -->
                                                    <td v-if="index === 0" :rowspan="rules.length">
                                                        {{ platform }}
                                                    </td>
                                                    <td style="width: 70px; text-align: center">
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${rule.id}`"
                                                            :value="rule.id"
                                                            :label="``"
                                                        />
                                                    </td>
                                                    <td :class="`${isActiveNotAutoCheck(rule.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ rule.rule }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <!-- Show mục X -->
                                            <template
                                                v-if="
                                                    platform === 'X' && platformsChecked.some((item) => item.value == 'X' || item.value == 'TikTok')
                                                "
                                            >
                                                <tr v-for="(rule, index) in rules" :key="rule.id">
                                                    <!-- Chỉ hiển thị platform ở dòng đầu -->
                                                    <td v-if="index === 0" :rowspan="rules.length">
                                                        {{ platform }}
                                                    </td>
                                                    <td style="width: 70px; text-align: center">
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${rule.id}`"
                                                            :value="rule.id"
                                                            :label="``"
                                                        />
                                                    </td>
                                                    <td :class="`${isActiveNotAutoCheck(rule.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ rule.rule }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <!-- Show mục WEB -->
                                            <template
                                                v-if="
                                                    platform === 'WEB' &&
                                                    platformsChecked.some((item) => item.value == 'WEB' || item.value == 'アプリ')
                                                "
                                            >
                                                <tr v-for="(rule, index) in rules" :key="rule.id">
                                                    <!-- Chỉ hiển thị platform ở dòng đầu -->
                                                    <td v-if="index === 0" :rowspan="rules.length">
                                                        {{ platform }}
                                                    </td>
                                                    <td style="width: 70px; text-align: center">
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${rule.id}`"
                                                            :value="rule.id"
                                                            :label="``"
                                                        />
                                                    </td>
                                                    <td :class="`${isActiveNotAutoCheck(rule.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ rule.rule }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <!-- Show mục ハガキ -->
                                            <template
                                                v-if="
                                                    platform === 'ハガキ' &&
                                                    platformsChecked.some((item) => item.value == 'ハガキ' || item.value == '店頭')
                                                "
                                            >
                                                <tr v-for="(rule, index) in rules" :key="rule.id">
                                                    <!-- Chỉ hiển thị platform ở dòng đầu -->
                                                    <td v-if="index === 0" :rowspan="rules.length">
                                                        {{ platform }}
                                                    </td>
                                                    <td style="width: 70px; text-align: center">
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${rule.id}`"
                                                            :value="rule.id"
                                                            :label="``"
                                                        />
                                                    </td>
                                                    <td :class="`${isActiveNotAutoCheck(rule.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ rule.rule }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <!-- Show mục Instagram -->
                                            <template
                                                v-if="
                                                    platform === 'Instagram' &&
                                                    platformsChecked.some((item) => item.value == 'Instagram' || item.value == 'TikTok')
                                                "
                                            >
                                                <tr v-for="(rule, index) in rules" :key="rule.id">
                                                    <!-- Chỉ hiển thị platform ở dòng đầu -->
                                                    <td v-if="index === 0" :rowspan="rules.length">
                                                        {{ platform }}
                                                    </td>
                                                    <td style="width: 70px; text-align: center">
                                                        <InputCheckBox
                                                            :model.sync="dataForm.rules"
                                                            :id="`checkar${rule.id}`"
                                                            :value="rule.id"
                                                            :label="``"
                                                        />
                                                    </td>
                                                    <td :class="`${isActiveNotAutoCheck(rule.id) ? 'rule__condition_checked_not_auto' : ''}`">
                                                        {{ rule.rule }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-6" style="word-wrap: break-word; border: #efefef 1px solid">
                                <div v-if="loadingDetail" class="mt-5" style="position: absolute; left: 50%; transform: translateX(-50%)">
                                    <LoadingIcon />
                                </div>
                                <div v-else>
                                    <h3 class="text-center mt-2">応募規約</h3>
                                    <div v-for="(item, k) in dataForm.rule_details" :key="k">
                                        <p class="p-2">{{ item.detail }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)">
                        <LoadingIcon />
                    </div>
                </div>
            </form>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

import { validateField } from '@/utils/validate';
import { InputCheckBox } from '@/components/Input';
import { configs } from '../../main';
import { masterMethods } from '@/state/helpers';

export default {
    name: 'Modal-Condition-Rule',
    components: {
        ModalCommon,
        LoadingIcon,
        Multiselect,
        InputCheckBox
    },
    props: {
        masterClients: {
            required: true,
            type: Array,
            default: () => []
        },
        campaignType: {
            required: true,
            type: String,
            default: () => []
        },
        listCategoriesCampaign: {
            required: true,
            type: Array,
            default: () => []
        },
        listCategoriesMaster: {
            required: true,
            type: Array,
            default: () => []
        },
        listAllRule: {
            required: true,
            type: Array,
            default: () => []
        },
        formRule: {
            default: () => null
        },
        loading: {
            type: Boolean,
            default: () => false
        },
        config: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            configFieldSelectClient: configs.configFieldSelectClient,
            dataForm: this.formRule,
            listDetailRule: [],
            loadingDetail: false
        };
    },
    computed: {
        platformsChecked() {
            return this.listCategoriesMaster.filter((item) => this.dataForm.platforms.includes(item.id));
        },
        platforms() {
            let platforms = [];
            this.platformsChecked.forEach((item) => {
                switch (item.value) {
                    case 'WEB':
                        platforms.push('PF_WEB');
                        break;
                    case 'ハガキ':
                        platforms.push('PF_POSTCARD');
                        break;
                    case 'X':
                        platforms.push('PF_TWITTER');
                        break;
                    case 'Instagram':
                        platforms.push('PF_INSTAGRAM');
                        break;
                    case 'LINE':
                        platforms.push('PF_LINE');
                        break;
                }
            });
            return platforms;
        },
        ruleType1() {
            return this.listAllRule.filter((item) => item.type === 1);
        },
        ruleType2() {
            return this.listAllRule.filter((item) => item.type === 2);
        },
        ruleType3() {
            return this.listAllRule.filter((item) => item.type === 3);
        },

        isActiveNotAutoCheck() {
            return (ruleId) => {
                return this.dataForm.manualSelected.includes(ruleId);
            };
        },
        groupedRules3() {
            // Gom theo platform.value
            const groups = {};
            this.ruleType3.forEach((rule) => {
                rule.platforms.forEach((p) => {
                    const platform = p.value;
                    if (!groups[platform]) groups[platform] = [];

                    // kiểm tra xem rule đã tồn tại trong nhóm này chưa
                    if (!groups[platform].some((r) => r.id === rule.id)) {
                        groups[platform].push(rule);
                    }
                });
            });
            return groups;
        }
    },
    watch: {
        formRule: {
            handler: function (newFormOther) {
                this.dataForm = newFormOther;
            },
            immediate: true
        },
        dataForm: {
            handler: function (newDataForm) {
                this.$emit('update:formRule', newDataForm);
            },
            immediate: true
        }
    },

    methods: {
        ...masterMethods,
        handleClose() {
            this.config.model = false;
            this.configFieldSelectClient.error = false;
            this.$emit('close');
        },
        async getDetailRule() {
            const dataObject = {
                rules: this.dataForm.rules,
                platforms: this.platforms
            };
            try {
                this.loadingDetail = true;
                const { data } = await this.getDetailRuleCondition(dataObject);
                this.dataForm.rule_details = data;
            } catch (error) {
                this.loadingDetail = false;
            } finally {
                this.loadingDetail = false;
            }
        },

        handleChangeCategory() {
            const platformsCheckedValues = this.platformsChecked.map((item) => item.value);
            // Lọc bỏ các ruleType3 không thuộc category đã chọn
            if (!platformsCheckedValues.includes('ハガキ') && !platformsCheckedValues.includes('店頭')) {
                this.removeRulesByCategory('ハガキ');
            }
            if (!platformsCheckedValues.includes('WEB') && !platformsCheckedValues.includes('アプリ')) {
                this.removeRulesByCategory('WEB');
            }
            if (!platformsCheckedValues.includes('X') && !platformsCheckedValues.includes('TikTok')) {
                this.removeRulesByCategory('X');
            }
            if (!platformsCheckedValues.includes('Instagram') && !platformsCheckedValues.includes('TikTok')) {
                this.removeRulesByCategory('Instagram');
            }
            if (!platformsCheckedValues.includes('LINE')) {
                this.removeRulesByCategory('LINE');
            }
        },

        setConditionRule() {
            let check = validateField(this.configFieldSelectClient, true);
            if (!check) return;
            this.config.model = false;
            this.dataForm.platformsSend = this.platforms;
            this.$emit('saveConditionRule', this.dataForm);
        }
    }
};
</script>

<style lang="scss" scoped>
.rule__condition_checked_not_auto {
    color: #0066ff;
}
</style>
